
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Подписки на рассылку', path: '/preferences' },
            { id: 2, name: 'Лиды', path: '/preferences/leads' },
        ]

        return { tabs }
    },
})
